import { MaterialFormInfoListItem, useApiMaterialsV1MaterialFormsRetrieve } from 'api';
import { capitalizeString } from 'ui';

import {
  MultiAutocompleteField,
  type MultiAutocompleteFieldProps,
} from '../MultiAutocompleteField/MultiAutocompleteField';

type Props = Omit<
  MultiAutocompleteFieldProps<MaterialFormInfoListItem>,
  'options' | 'isOptionEqualToValue' | 'getOptionLabel'
>;

export const MultiMaterialFormAutocompleteField = (props: Props) => {
  const { data, isLoading } = useApiMaterialsV1MaterialFormsRetrieve();

  return (
    <MultiAutocompleteField<MaterialFormInfoListItem>
      options={data?.results || []}
      loading={isLoading}
      valueField="id"
      getOptionLabel={(option) => `${capitalizeString(option.type)}`}
      isOptionEqualToValue={(option, value) => {
        return value === undefined || option?.id?.toString() === (value?.id ?? value)?.toString();
      }}
      {...props}
    />
  );
};
